import { render, staticRenderFns } from "./detail_config_dataset_edit.vue?vue&type=template&id=4e65a2ba"
import script from "./detail_config_dataset_edit.vue?vue&type=script&lang=js"
export * from "./detail_config_dataset_edit.vue?vue&type=script&lang=js"
import style0 from "./detail_config_dataset_edit.vue?vue&type=style&index=0&id=4e65a2ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports